import _ from "underscore"
import { bindActionCreators } from "redux"
import TemplateView from "../../TemplateView"
import {connect} from "../../redux/utils"
import ClassicBridge from "../../next/ClassicBridge"
import { getAvailableFilters, getSelectedFilterKeys } from "../common/selectors"
import { setSelectedFilterKeys } from "../common/actions"

class AddFiltersContainer extends TemplateView {
    constructor({
        setSelectedFilterKeys
    }) {
        super()

        this.state = {
            availableFilters: [],
            selectedFilterKeys: []
        }

        this.actions = {
            setSelectedFilterKeys
        }

        this.onStatePropertyChanged('availableFilters', (availableFilters) => {
            this.addFilters.setProps({
                fields: availableFilters
            })
        })

        this.onStatePropertyChanged('selectedFilterKeys', (selectedFilterKeys) => {
            this.addFilters.setProps({
                selectedFieldKeys: selectedFilterKeys
            })
        })
    }

    templateHtml() {
        return "<div class='taskAddFilters'></div>"
    }

    afterRender() {
        this.addFilters = ClassicBridge.integrateAddFilters(this.$el[0], {
            fields: this.state.availableFilters,
            selectedFieldKeys: this.state.selectedFilterKeys,
            onApply: this.actions.setSelectedFilterKeys,
        })

        this.renderInitialState()
    }
}

export default connect(
    (state) => ({
        availableFilters: getAvailableFilters(state),
        selectedFilterKeys: getSelectedFilterKeys(state)
    }),
    (dispatch) => ({
        setSelectedFilterKeys: bindActionCreators(setSelectedFilterKeys, dispatch)
    })
)(AddFiltersContainer)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/AddFiltersContainer.js